{
    "header": "טבלה כוללת",
    "nedarim": "נדרים",
    "commit": "התחיבויות",
    "total": "סך הכל",
    "fullName": "שם מלא",
    "Asdasd": ""
}